import { get } from 'lodash'

export function isEnableEssentialApps () {
  const toggleKey = 'enableEssentialApp'
  return get(window.dataModel, toggleKey, false) || get(window.newBillingConfig, toggleKey, false)
}